export default __webpack_public_path__ + "static/media/logo.46a96376.svg";